import React from 'react';
import { useIntl } from 'react-intl';

import type { InfoItemProps } from '../../InfoItem/InfoItem';
import type { InfoItemsProps } from '../InfoItemsContainer';
import InfoItemsList from '../InfoItemsList';
import { getPrizePoolItem, getTimeItemStartsInRegOpens } from '../utils';

const InfoItemsAnnounced: React.FC<InfoItemsProps> = ({ tournament, timesData }) => {
  const intl = useIntl();

  const infoItems: InfoItemProps[] = [
    getTimeItemStartsInRegOpens(timesData, intl),
    getPrizePoolItem(tournament)
  ];

  return <InfoItemsList infoItems={infoItems} />;
};

export default InfoItemsAnnounced;
